<template>
  <!-- 
    Code By     : 陈伦刚
    CreateTime  : 2021-04-13 05:00:20
    Description : 播放页面
  -->
  <div>
    <div class="player-background">
      <div class="player">
        <div
          v-loading="!showVideo"
          style="min-height: 600px; background: #010001"
        >
          <gaia-player2 v-if="showVideo" :src="videoSrc" @end="playEnd" />
        </div>
        <div class="info">
          <div class="title">
            <span style="margin-right: 40px">{{ hourWorks.title }}</span>
            <good-one
              :theme="isLike ? 'filled' : 'outline'"
              size="40"
              fill="#ffa200"
              style="cursor: pointer"
              @click="worksAgree"
            />
            <span class="text" style="vertical-align: middle">
              投票 ({{ likeCount }})
            </span>
          </div>
          <div class="text">
            <div>{{ hourWorks.year }} | No.{{ hourWorks.number }}</div>
            <div>
              <span v-for="(item, i) in hourWorks.creators" :key="item.id">
                {{ `${item.position}：${item.name}` }}
                <span v-if="i !== hourWorks.creators.length - 1"> / </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="detail">
      <div style="width: 1200px; margin: 0 auto">
        <el-tabs type="border-card">
          <el-tab-pane label="短片简介">
            <div style="padding: 50px 80px">
              <div class="info">
                <div>编号：No.{{ hourWorks.number }}</div>
                <div>
                  分站：{{ hourWorks.area.text }}｜
                  {{ hourWorks.area.pinyin }}
                  （ {{ hourWorks.area.startTime }} －
                  {{ hourWorks.area.endTime }}）
                </div>
                <div v-html="hourWorks.description"></div>
              </div>
              <div class="cover">
                <img :src="baseUrl + hourWorks.cover" />
              </div>
              <el-divider />
              <div class="story-title">缘起</div>
              <div class="story">
                <div v-html="hourWorks.story"></div>
                <div v-if="!hourWorks.story">暂无缘起</div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="创作人">
            <div style="padding: 80px">
              <div v-for="(item, i) in users" :key="item.id" class="user">
                <div class="position">{{ item.position }}</div>
                <div class="name">{{ item.name }}</div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="剧本/分镜">
            <div style="padding: 50px 80px">
              <div v-html="hourWorks.script"></div>
              <div v-if="!hourWorks.script">暂无内容</div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import gaiaPlayer2 from "@/components/gaia-player/gaia-player2";
import { GoodOne } from "@icon-park/vue";
import { getDetail, worksAgree } from "@/api/newgaia48";
export default {
  components: {
    gaiaPlayer2,
    GoodOne,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_RESOURCES_URL,
      id: 0,
      users: [{ id: 704, name: "周昕 ", position: "导演", userId: 0 }],
      hourWorks: {
        creators: [],
        area: {},
        user: {
          account: {
            id: "",
          },
        },
        video: {},
      },
      videoSrc: "",
      showVideo: false,
      likeCount: 0,
      isLike: false,
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getDetail();
  },
  beforeDestroy() {
    window.myPlayer.dispose();
  },
  methods: {
    getDetail() {
      getDetail(this.id).then((res) => {
        this.hourWorks = res.hourWorks;
        res.hourWorks.video.resources.map((el) => {
          if (el.type === "HLS_AVC") {
            this.videoSrc = this.baseUrl + el.resourceKey;
            this.showVideo = true;
          }
        });
        this.users = res.hourWorks.creators;
        this.isLike = res.isLike;
        this.likeCount = res.likeCount;
      });
    },
    playEnd() {},
    worksAgree() {
      worksAgree(this.id).then((res) => {
        this.getDetail();
        if (res.msg.includes("cancel")) {
          this.$message.success("取消点赞成功");
        } else {
          this.$message.success("点赞成功");
        }
      });
    },
  },
};
</script>

<style lang="less">
.video-js {
  height: 600px !important;
}
.el-tabs__content {
  min-height: 300px;
  background: #353940;
}
.el-tabs--border-card {
  border: none;
  color: #b2b2b2;
}
.el-tabs--border-card > .el-tabs__header {
  background: #41464e;
  border: none;
}
.el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item:not(.is-disabled):hover {
  color: #ffa200;
}
.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  background: #353940;
  color: #ffa200;
  border: none;
}
.el-tabs--border-card > .el-tabs__header .el-tabs__item {
  transition: all 0s;
}
</style>
<style lang="less" scoped>
.player {
  width: 1200px;
  height: 875px;
  padding-top: 74px;
  margin: 0 auto;
}
.player-background {
  padding-top: 60px;
  min-width: 1300px;
  background: #1a1a1a;
}
.info {
  padding: 30px 0;
  color: #b2b2b2;
  min-height: 200px;
  .title {
    font-size: 50px;
  }
  .text {
    font-size: 16px;
  }
}
.detail {
  min-width: 1300px;
  min-height: 500px;
  padding: 100px 0;
  background: #41464e;
}
.user {
  display: inline-block;
  margin-right: 43.8%;
  margin-bottom: 20px;
  text-align: center;
  .position {
    font-size: 20px;
    color: #ffa200;
    border-bottom: 6px solid #ffa200;
    margin-bottom: 10px;
  }
  .name {
    font-size: 16px;
    color: #ffffff;
  }
}
.user:nth-child(3n + 3) {
  margin-right: 0;
}
.info {
  display: inline-block;
  width: 80%;
  font-size: 20px;
  line-height: 30px;
}
.cover {
  float: right;
  margin-top: 20px;
  min-width: 100px;
  max-width: 100px;
  min-height: 145px;
  max-height: 145px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    min-width: 100px;
    max-width: 100px;
    min-height: 145px;
    max-height: 145px;
  }
}
.el-divider {
  background-color: #555b66;
}
.story-title {
  display: inline-block;
  height: 30px;
  line-height: 30px;
  padding-right: 30px;
  font-size: 14px;
  padding-left: 20px;
  background: #4a5060;
  color: #b2b2b2;
  border-left: solid 20px #ffa200;
}
.story {
  margin: 20px 0;
  font-size: 18px;
  line-height: 30px;
  color: #b2b2b2;
}
</style>